<template>
  <div class=" w-full h-full">
    <div
      v-for="inputValue in output.rules"
      :key="inputValue.id"
      class="py-1"
    >
      <QueryBuilderRow
        v-if="inputValue.type != 'group'"
        :input-value="inputValue"
        @delete-row="onDeleteRow"
      />
      <QueryBuilderGroup
        v-if="inputValue.type == 'group'"
        :input-value="inputValue"
        :index="index"
        @delete-row="onDeleteRow"
        @delete-group="onDeleteGroup"
        @update-value="onUpdateValue"
      />
    </div>
  </div>
</template>


<script>
  import QueryBuilderGroup from "@/components/QueryBuilder/QueryBuilderGroup.vue";
    import QueryBuilderRow from "@/components/QueryBuilder/QueryBuilderRow.vue";

    export default {
        name: 'QueryBuilderRows',
        components: { QueryBuilderRow , QueryBuilderGroup},
        props: {
            inputValue: Object
        },
        data: function () {
            return {
                output: {}
            }
 
        },
        watch:
        {
            inputValue: function () {
                this.output = this.inputValue
            }
        },
        mounted() {
            this.output = this.inputValue
        },
        methods : 
        {
            onDeleteRow: function (event)
            {
                console.log("QueryBuilderRows","onDeleteRow")
 
                const output = this.output.rules.filter(function (item) { return item.id !== event.id; });
              //  console.log(event.id, output)
                this.output.rules = output

                let newevent = { id: this.output.id, rules: this.output.rules}
                this.$emit("updateValue", newevent)

 
            }
        }



    }
</script>